import { render, staticRenderFns } from "./CambiarImagen.vue?vue&type=template&id=63aba799"
import script from "./CambiarImagen.vue?vue&type=script&lang=js"
export * from "./CambiarImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports